import React, { createContext, useCallback, useContext } from 'react'

type RefreshContextType = {
  refresh: () => void
  refreshCount: number
}

const RefreshContext = createContext<RefreshContextType | undefined>(undefined)

export const RefreshProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [refreshCount, setRefreshCount] = React.useState(0)
  const refresh = useCallback(() => {
    setRefreshCount(prevCount => prevCount + 1)
  }, [])

  return (
    <RefreshContext.Provider value={{ refresh, refreshCount }}>
      {children}
    </RefreshContext.Provider>
  )
}

export const useRefreshContext = () => {
  const context = useContext(RefreshContext)
  if (!context) {
    throw new Error('useRefresh must be used within a RefreshProvider')
  }
  return context
}

export const useRefresh = (callOnRefreshNeeded: () => void) => {
  const { refreshCount } = useRefreshContext()
  React.useEffect(() => {
    if (refreshCount > 0) {
      callOnRefreshNeeded()
    }
  }, [refreshCount])
}
